export const getExtension = (fileName: string) => {
  const extension = fileName.split('.').pop();
  return extension ? extension.toLowerCase() : '';
};
